import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { IFormPresentLevels } from "../Models/Forms/IFormPresentLevels";

@Injectable()
export class FormPresentLevelsService extends BaseService {
   
  _baseUrl: string = "";
  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string)
  {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormPresentLevels(id: number) {
    return this._http.get(this._baseUrl + "api/FormPresentLevels/" + id)
      .map((response: IFormPresentLevels) => response as IFormPresentLevels)
      .catch(this.errorHandler);
  }

  insertUpdateFormPresentLevels(formPresentLevelsDetails: IFormPresentLevels) {
    return this._http.post(this._baseUrl + 'api/FormPresentLevels', formPresentLevelsDetails)
      .map((response: IFormPresentLevels) => response as IFormPresentLevels)
      .catch(this.errorHandler);
  }

  deletePresentLevels(id) {
    return this._http.delete(this._baseUrl + "api/FormPresentLevels" + id)
      .map((response: IFormPresentLevels) => response as IFormPresentLevels)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }

}


